import {Product} from '../../types';

export const filterByComponents = (products: Product[], componentIds: string[]) : Product[] => {
    return products.filter(product => {
        return componentIds.every(id => product.components.some(pc => pc.id === id));
    })
};